import React from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { useTranslation } from 'react-i18next'
import ServiceCTA from '../components/ServiceCTA'

const AppliedAIMLPage = () => {
    const { t } = useTranslation()

    return (
        <ServiceLayout
            breadcrumbs={[
                { label: t('header.home'), path: '/' },
                { label: t('header.service'), path: '/service' },
                { label: t('header.services.aiMl.title'), path: '/service/ai-ml' },
                { label: t('aiMlOverview.appliedAiPage.title') }
            ]}
            title={t('aiMlOverview.appliedAiPage.title')}
            titleStyle={{ marginBottom: '50px' }}
        >
            <div className="space-y-8">
                <div className="bio-card-static rounded-xl p-6 border border-border-light">
                    <h2 className="text-xl font-bold text-text-main mb-4">{t('aiMlOverview.appliedAiPage.customSolutionTitle')}</h2>
                    <p className="text-sm text-text-muted leading-relaxed whitespace-pre-line">
                        {t('aiMlOverview.appliedAiPage.intro')}
                    </p>
                </div>

                <div className="bio-card-tinted rounded-2xl p-6 sm:p-8 border border-primary/20 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left mt-16">
                    <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white shadow-soft flex items-center justify-center text-primary flex-shrink-0">
                        <span className="material-symbols-outlined text-3xl">contact_support</span>
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-display font-bold text-text-main mb-2 break-words">{t('aiMlOverview.appliedAiPage.consultancyCta')}</h3>
                        <p className="text-sm text-text-muted mb-4 break-words">{t('aiMlOverview.appliedAiPage.consultancyCtaDesc')}</p>
                        <div className="flex flex-wrap gap-3 justify-center sm:justify-start">
                            <a href="/contact" className="btn-primary px-5 py-2 text-xs flex items-center gap-2">
                                {t('aiMlOverview.appliedAiPage.contactBtn')} <span className="material-symbols-outlined text-sm">arrow_forward</span>
                            </a>
                            <a href="/service-process" className="px-5 py-2 text-xs font-bold text-text-muted hover:text-primary transition-colors flex items-center gap-1.5">
                                {t('aiMlOverview.appliedAiPage.serviceProcessBtn')} <span className="material-symbols-outlined text-sm">arrow_forward</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </ServiceLayout>
    )
}

export default AppliedAIMLPage
